export enum AssessmentStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  DRAFT = "DRAFT",
}

export enum AssessmentDifficultyLevelEnum {
  EASY = "EASY",
  MEDIUM = "MEDIUM",
  HARD = "HARD",
}

export enum AssessmentQuestionTypes {
  "MCQ" = "MCQ",
  "SUBJECTIVE" = "SUBJECTIVE",
  "PSEUDO-CODE" = "PSEUDO-CODE",
  "CODE" = "CODE",
}

export enum QuestionDifficultyLevelEnum {
  EASY = "EASY",
  MEDIUM = "MEDIUM",
  HARD = "HARD",
}
